import React from 'react';
import { Icon } from './Icon.js';
export const IconPuzzlePiece2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M1 12C1 13.6569 2.34315 15 4 15V21H9C9 19.3431 10.3431 18 12 18C13.6569 18 15 19.3431 15 21H20L20 15C21.6569 15 23 13.6569 23 12C23 10.3431 21.6569 9 20 9L20 3H15C15 4.65685 13.6569 6 12 6C10.3431 6 9 4.65685 9 3H4V9C2.34315 9 1 10.3431 1 12Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPuzzlePiece2.js.map